export const ROOM_TYPES = [
  { id: 'living_room', label: 'Living Room' },
  { id: 'bedroom', label: 'Bedroom' },
  { id: 'office', label: 'Home Office' },
  { id: 'kitchen', label: 'Kitchen' },
  { id: 'dining_room', label: 'Dining Room' },
  { id: 'nursery', label: 'Nursery' },
];

export const DEFAULT_ROOM_TYPE = 'living_room';

export const roomLabel = (id) => ROOM_TYPES.find((r) => r.id === id)?.label || (id ? id.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase()) : 'Living Room');

// Scene / style vocab used by AI room generation (admin)
export const GEN_ROOM_SCENES = ['living room', 'bedroom', 'dining room', 'home office', 'kitchen', 'bathroom', 'nursery', 'sunroom'];
export const GEN_STYLES = ['modern minimalist', 'contemporary', 'traditional', 'scandinavian', 'industrial', 'coastal', 'farmhouse', 'mid-century modern', 'bohemian'];
